export default __webpack_public_path__ + "static/media/MOFSL-Post-Log-In-370X120.b14a1e7d.jpg";